<div class="about-page-container">
  
  <!-- Hero Section -->
  <section class="about-hero py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 mb-4 mb-lg-0">
          <span class="badge bg-light text-primary font-weight-bold mb-3 px-3 py-2">
            <i class="fas fa-flag mr-1 text-danger"></i> COMERCIO 100% COLOMBIANO
          </span>
          <h1 class="display-4 font-weight-bold mb-3">Revolucionando el <span class="text-primary">Comercio Electrónico</span> en Colombia</h1>
          <p class="lead text-muted mb-4">Nacimos para democratizar la desconfianza digital. Conectamos a más de 1.100 municipios con un modelo pionero de <strong>Pago Contra Entrega en efectivo o Nequi</strong>, respaldado por los 4 centros de distribución más eficientes de la región andina y caribe.</p>
          
          <div class="hero-actions d-flex gap-3">
            <a routerLink="/shop" class="btn btn-primary btn-lg font-weight-bold px-4">
              <i class="fas fa-shopping-bag mr-2"></i> Explorar Catálogo Nacional
            </a>
            <a routerLink="/contact" class="btn btn-outline-secondary btn-lg font-weight-bold px-4">
              <i class="fas fa-users mr-2"></i> Conocer Nuestro Equipo
            </a>
          </div>
        </div>

        <div class="col-lg-5 text-center">
          <div class="hero-image-wrapper p-3 bg-white rounded shadow-lg border">
            <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80" alt="CEDI Colombia" class="img-fluid rounded">
            <div class="hero-image-badge p-3 bg-primary text-white rounded mt-3 text-left">
              <div class="d-flex align-items-center">
                <i class="fas fa-warehouse fa-2x mr-3"></i>
                <div>
                  <h6 class="font-weight-bold mb-0">CEDI Funza Principal</h6>
                  <small>Área Metropolitana Bogotá D.C. &bull; Operación 24/7</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Metrics Grid -->
  <section class="metrics-section py-5 bg-white border-top border-bottom">
    <div class="container">
      <div class="row text-center">
        <div class="col-md-3 mb-4 mb-md-0">
          <div class="metric-card p-3">
            <h2 class="display-4 font-weight-bold text-primary mb-1">+180.000</h2>
            <p class="font-weight-bold mb-1">Entregas Exitosas</p>
            <small class="text-muted">Órdenes cobradas y verificadas en la puerta del hogar</small>
          </div>
        </div>

        <div class="col-md-3 mb-4 mb-md-0">
          <div class="metric-card p-3">
            <h2 class="display-4 font-weight-bold text-success mb-1">1.100+</h2>
            <p class="font-weight-bold mb-1">Municipios Atendidos</p>
            <small class="text-muted">De los Andes a la Amazonía sin recargos ocultos</small>
          </div>
        </div>

        <div class="col-md-3 mb-4 mb-md-0">
          <div class="metric-card p-3">
            <h2 class="display-4 font-weight-bold text-info mb-1">4 Hubs</h2>
            <p class="font-weight-bold mb-1">Bodegas Propias</p>
            <small class="text-muted">Funza, Sabaneta, Yumbo y Galapa</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="metric-card p-3">
            <h2 class="display-4 font-weight-bold text-warning mb-1">99.4%</h2>
            <p class="font-weight-bold mb-1">Índice de Satisfacción</p>
            <small class="text-muted">Evaluaciones con 5 estrellas en postventa</small>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Pillars of Trust -->
  <section class="pillars-section py-5 container">
    <div class="text-center mb-5">
      <span class="badge bg-light text-primary font-weight-bold mb-2">PILARES INNEGOCIABLES</span>
      <h2 class="font-weight-bold">Cómo construimos confianza en cada rincón del país</h2>
      <p class="text-muted">Nuestras cuatro columnas operativas diseñadas para eliminar el riesgo del consumidor colombiano.</p>
    </div>

    <div class="row">
      <div class="col-md-3 mb-4">
        <div class="pillar-card p-4 bg-white rounded shadow-sm border text-center h-100">
          <div class="pillar-icon bg-light-success text-success p-3 rounded-circle d-inline-block mb-3">
            <i class="fas fa-hand-holding-usd fa-2x"></i>
          </div>
          <h5 class="font-weight-bold">Confianza Total & Cero Riesgo</h5>
          <p class="small text-muted mb-0">Eliminamos el temor al fraude digital. Solamente pagas en efectivo o Nequi cuando tienes el paquete en tus manos.</p>
        </div>
      </div>

      <div class="col-md-3 mb-4">
        <div class="pillar-card p-4 bg-white rounded shadow-sm border text-center h-100">
          <div class="pillar-icon bg-light-primary text-primary p-3 rounded-circle d-inline-block mb-3">
            <i class="fas fa-truck-loading fa-2x"></i>
          </div>
          <h5 class="font-weight-bold">Logística de Punta a Punta</h5>
          <p class="small text-muted mb-0">Integración directa con transportadoras nacionales (Servientrega, Coordinadora, Interrapidísimo, TCC) con rastreo por SMS.</p>
        </div>
      </div>

      <div class="col-md-3 mb-4">
        <div class="pillar-card p-4 bg-white rounded shadow-sm border text-center h-100">
          <div class="pillar-icon bg-light-warning text-warning p-3 rounded-circle d-inline-block mb-3">
            <i class="fas fa-shield-alt fa-2x"></i>
          </div>
          <h5 class="font-weight-bold">Sello y Garantía SIC</h5>
          <p class="small text-muted mb-0">Cumplimiento del Estatuto del Consumidor (Ley 1480). Derecho a retracto inmediato de 5 días hábiles y 30 días de garantía.</p>
        </div>
      </div>

      <div class="col-md-3 mb-4">
        <div class="pillar-card p-4 bg-white rounded shadow-sm border text-center h-100">
          <div class="pillar-icon bg-light-info text-info p-3 rounded-circle d-inline-block mb-3">
            <i class="fas fa-heart fa-2x"></i>
          </div>
          <h5 class="font-weight-bold">Apoyo al Talento Nacional</h5>
          <p class="small text-muted mb-0">El 82% de nuestro catálogo apoya talleres de confección e innovadores de tecnología colombiana.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Strategic Hubs -->
  <section class="hubs-section py-5 bg-white border-top">
    <div class="container">
      <div class="text-center mb-5">
        <span class="badge bg-light text-primary font-weight-bold mb-2">RED DE ALMACENAMIENTO</span>
        <h2 class="font-weight-bold">Bodegas Estratégicas AndesStore</h2>
      </div>

      <div class="row">
        <div class="col-md-3 mb-4" *ngFor="let hub of hubs">
          <div class="hub-card p-4 rounded border bg-light h-100">
            <span class="badge bg-primary text-white mb-2">{{ hub.tag }}</span>
            <h5 class="font-weight-bold mb-2">{{ hub.city }}</h5>
            <p class="small text-muted mb-2"><strong>Área:</strong> {{ hub.area }}</p>
            <p class="small text-muted mb-2"><strong>Cobertura:</strong> {{ hub.coverage }}</p>
            <div class="hub-capacity font-weight-bold text-success small mt-3">
              <i class="fas fa-bolt mr-1"></i> {{ hub.capacity }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Final Call to Action -->
  <section class="cta-section py-5 bg-primary text-white text-center">
    <div class="container">
      <h2 class="display-5 font-weight-bold mb-3">¿Listo para estrenar sin preocuparte por tu dinero?</h2>
      <p class="lead mb-4">Descubre miles de productos verificados con entrega a domicilio y pago en efectivo en cualquier rincón de Colombia.</p>
      <a routerLink="/shop" class="btn btn-light btn-lg font-weight-bold px-5 text-primary">
        <i class="fas fa-shopping-cart mr-2"></i> Explorar Tienda Ahora
      </a>
    </div>
  </section>

</div>
